/**
 * Per-workspace internal sidebar collapse prefs.
 * Mirrors app-rail `multi-chat:sidebar-collapsed` (`"true"` / `"false"`).
 * Each workspace has its own key so collapsing Contacts does not collapse Campaigns/Reports.
 */

export const WORKSPACE_SIDEBAR_COLLAPSED_KEYS = {
  contacts: "multi-chat:contacts-sidebar-collapsed",
  campaigns: "multi-chat:campaigns-sidebar-collapsed",
  reports: "multi-chat:reports-sidebar-collapsed",
  settings: "multi-chat:settings-sidebar-collapsed",
  channels: "multi-chat:channels-sidebar-collapsed",
  superAdminSettings: "multi-chat:super-admin-settings-sidebar-collapsed",
} as const;

export type WorkspaceSidebarId = keyof typeof WORKSPACE_SIDEBAR_COLLAPSED_KEYS;

export const WORKSPACE_SIDEBAR_COLLAPSED_DEFAULT = false;

export function readWorkspaceSidebarCollapsedPreference(storageKey: string): boolean {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (raw === "true") return true;
    if (raw === "false") return false;
    return WORKSPACE_SIDEBAR_COLLAPSED_DEFAULT;
  } catch {
    return WORKSPACE_SIDEBAR_COLLAPSED_DEFAULT;
  }
}

export function writeWorkspaceSidebarCollapsedPreference(
  storageKey: string,
  collapsed: boolean,
): void {
  try {
    window.localStorage.setItem(storageKey, collapsed ? "true" : "false");
  } catch {
    // Quota / private mode — keep in-memory only.
  }
}
